import React from 'react'
import { Nav, NavItem } from 'react-bootstrap'
import { Route, Switch } from 'react-router-dom'
import RouteMatcher from '~/RouteMatcher'
import BlueprintScreen from './BlueprintScreen'
import RawBlueprintScreen from './RawBlueprintScreen'
import BlueprintTranslationScreen from '~/screens/blueprint/BlueprintTranslationScreen';
import AttributesScreen from '~/screens/attribute/AttributesScreen'
import { View } from '~/views';

export default class BlueprintHomeScreen extends React.Component {

  static routes = [
    <Route key="/project/:projectId/blueprint/:blueprintId" path="/project/:projectId/blueprint/:blueprintId" exact component={BlueprintScreen} />,
    <Route key="/project/:projectId/blueprint/:blueprintId/" path="/project/:projectId/blueprint/:blueprintId/" exact component={BlueprintScreen} />,
    <Route key="/project/:projectId/blueprint/:blueprintId/info" path="/project/:projectId/blueprint/:blueprintId/info" exact={false} component={BlueprintScreen} />,
    <Route key="/project/:projectId/blueprint/:blueprintId/attributes" path="/project/:projectId/blueprint/:blueprintId/attributes" exact={false} component={AttributesScreen} />,
    <Route key="/project/:projectId/blueprint/:blueprintId/raw" path="/project/:projectId/blueprint/:blueprintId/raw" exact component={RawBlueprintScreen} />,
    <Route key="/project/:projectId/blueprint/:blueprintId/raw" path="/project/:projectId/blueprint/:blueprintId/translation" exact component={BlueprintTranslationScreen} />
  ]

  constructor( props ) {
    super( props );

    this.routeMatcher = new RouteMatcher( BlueprintHomeScreen.routes, { missComponent : null } )

  }

  onTabSelected = ( key, evt ) => {
    const { match, history } = this.props
    const { projectId, blueprintId } = match.params
    history.push( `/project/${projectId}/blueprint/${blueprintId}/${key}` )
  }

  render() {
    const { location } = this.props

    const matchResult = this.routeMatcher.find( location )

    const activeKey = matchResult.matchIndex === 5 ? 'translation' :
      matchResult.matchIndex === 3 ? 'attributes' : 
        'info'
    
    return ( 
      <View style={{ display : 'flex', flexDirection : 'column', overflow : 'hidden' }}>
        <Nav bsStyle="tabs" activeKey={activeKey} onSelect={this.onTabSelected}>
          <NavItem eventKey="info">Info</NavItem>
          <NavItem eventKey="attributes">Attributes</NavItem>
          <NavItem eventKey="translation">Translation</NavItem>
        </Nav>

        <div style={{ flex : 1, overflow : 'auto', position : 'relative' }}>
          <Switch>
            {BlueprintHomeScreen.routes}
          </Switch>
        </div>
      </View>
    )
  }
}
